/*
*
* File JS Principale
*
*/
// IMPORT JQUERY
//--------------------------------------------------------------------//

import $ from 'jquery';


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import 'scss/app.scss';
import 'swiper/css/bundle';
import "@lottiefiles/lottie-player";

//--------------------------------------------------------------------//

// Carichiamo i font in maniera asincrona
//--------------------------------------------------------------------//



var Webfont = require('webfontloader');

Webfont.load(
{
    google: {
        families: [
            "Cormorant:300,400,500,600,700",
            "Playfair Display:300,400,500,600,700",
            // "Public Sans:300,400,500,600,700",
            "Inter: 300,400,500,600,700"
        ],
    }
});



// window.WebFontConfig =
// {
//     typekit: { id: 'jfh0vsm' }
// };

// (function(d)
// {
//     var wf = d.createElement('script'), s = d.scripts[0];
//     wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
//     wf.async = true;
//     s.parentNode.insertBefore(wf, s);
// })(document);


// Variabili globali
//--------------------------------------------------------------------//

window.IM_GLOBAL =
{
    resolutions:
    {
        mobile:             0,
        tabletPortrait:   768,
        tabletLandscape: 1024,
        desktopExtended: 1441,
        headerExpanded:  1025
    },
    size:
    {
        paddingMobile:    30,
        paddingTablet:    30,
        paddingDesktop:   40
    },
    filterOperators : 
    {
        //Purchase:
        'purchase-type'         : '=',
        'purchase-Builder'      : '=',
        'purchase-StateRooms'   : '=',
        'purchase-Sleeps'       : '=',
        'purchase-Country'      : '=',
        'purchase-HullMaterial' : '=',
        'purchase-MainCategory' : '=',

        'purchase-yacht-name'   : 'LIKE',

        'purchase-LOA-min'      : '>=',
        'purchase-LOA-max'      : '<=',

        "purchase-Year-min"     : '>=',
        "purchasey-Year-max"    : '<=',

        "purchase-price-min"    : '>=',
        "purchase-price-max"    : '<=',
    
        "purchase-gross-tonnage-min" : '>=',
        "purchase-gross-tonnage-max" : '<=',
    
        //Charter:
        "charter-areas"          : '=',
        "charter-guestsSleeping" : '=',
        "charter-cabins"         : '=',
        "charter-builder"        : '=',
        "charter-hull"           : '=',

        "charter-date"           : 'Date',

        "charter-price-min"      : '>=',
        "charter-price-max"      : '<=',

        'charter-length-min'     : '>=',
        'charter-length-max'     : '<=',
    },
    specialPrefixes :
    [
        //Purchase
        'purchase-LOA',
        'purchase-Year',
        'purchase-price',
        'purchase-gross-tonnage',

        //Charter
        'charter-length',
        'charter-price',
        'charter-date',
    ],
    // Mappa i valori per passarli in modo strutturato al Back
    mappingValues(filterValues, filterOperators) {
        // Creiamo un nuovo oggetto per contenere il risultato
        let filters = {};

        // Iteriamo su tutte le proprietà dell'oggetto filterValues
        for (let key in filterValues) {
            if (filterValues.hasOwnProperty(key)) {
                // Otteniamo il valore e l'operatore corrispondente
                let values = filterValues[key];
                let operators = filterOperators[key];

                if(!values) continue;
    
                // Troviamo il prefisso corrispondente per questa chiave
                let matchedPrefix = window.IM_GLOBAL.specialPrefixes.find(prefix => key.startsWith(prefix));
    
                if (matchedPrefix) {
                    // Verifichiamo se filters[matchedPrefix] esiste già come array
                    if (!filters[cleanStringPrefix(matchedPrefix)]) {
                        filters[cleanStringPrefix(matchedPrefix)] = [];
                    }
                    // Aggiungiamo un oggetto con value o unit e operator
                    filters[cleanStringPrefix(matchedPrefix)].push({
                        // Se matchedPrefix contiene "currency" usa 'unit', altrimenti usa 'value'
                        ...(key.includes('currency') ? { unit: values } : { value: values }),
                        operator: operators
                    });

                    
                } else {
                    // Altrimenti, usiamo la chiave come è
                    if(values){
                        filters[cleanStringPrefix(key)] = {
                            value: values,
                            operator: operators
                        };
                    }
                }
            }
        }

        // Rimuoviamo 'price' se non ha almeno due elementi nell'array
        // if (filters['price'] && filters['price'].length < 2) {
        //     delete filters['price'];
        // }

        // Rimuoviamo 'length' se non ha almeno due elementi nell'array
        if (filters['LOA'] && filters['LOA'].length < 2) {
            delete filters['LOA'];
        }
        
        // if (filters['length'] && filters['length'].length < 2) {
        //     delete filters['length'];
        // }

        // Rimuove  il prefessio: "purchase-" e "charter-" dalla stringa
        function cleanStringPrefix(str) {
            return str.replace("purchase-", "").replace("charter-", "");
        }

        // Restituiamo l'oggetto con la struttura desiderata
        return { filters };
    },
    //Prendi tutti i Valori dei Filtri che hanno un valore
    getFiltersWithinWrapper(wrapper) {
        let filterValues = {};
    
        const inputs = wrapper.querySelectorAll('input, select');
    
        inputs.forEach(input => {
            const name = input.getAttribute('name');
            let value = '';
    
            if (input.type === 'radio') {
                if (input.checked) {
                    value = input.value;
                    filterValues[name] = value;
                }
            } else {
                value = input.value;
                filterValues[name] = value;
            }
                
        });
    
        return filterValues;
    }
};

//--------------------------------------------------------------------//


// Libreria Lazysizes
//--------------------------------------------------------------------//
import 'lazysizes';

//--------------------------------------------------------------------//

// Import Utilies
//--------------------------------------------------------------------//

import { animation } from 'components/animation/animation';


//--------------------------------------------------------------------//


// Init Utilies
//--------------------------------------------------------------------//

window.addEventListener('DOMContentLoaded', (evt) =>
{
    animation();
});
//--------------------------------------------------------------------//



// Import Componenti
//--------------------------------------------------------------------//

import prefooter from 'components/prefooter/prefooter';
import footer from 'components/footer/footer';
import header from 'components/header/header';
import breadcrumb from 'components/breadcrumb/breadcrumb'; 
import accordion from 'components/accordion/accordion';
import modal from 'components/modal/modal';
import filter from 'components/filter/filter';
import modalCookie from 'components/modal-cookie/modal-cookie';


//--------------------------------------------------------------------//


// Init Componenti
//--------------------------------------------------------------------//

window.addEventListener('DOMContentLoaded', (evt) =>
{
    header();
    accordion();
    modal();
    filter();
    modalCookie();
});

//--------------------------------------------------------------------//